import { render, staticRenderFns } from "./CustomerServiceTrackingNew.vue?vue&type=template&id=22d45843&"
import script from "./CustomerServiceTrackingNew.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceTrackingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports